'use strict';

import { loadEcho } from './Echo.js';

const session = {
	loaded: false,
	queue: [],
	
	guest: false,
	guestQueue: [],
};

export default {
	session: {
		setLoaded: () => {
			session.loaded = true;
			session.queue.forEach(callback => callback());
			session.queue = [];
		},
		
		setGuest: () => {
			if (session.loaded) {
				console.error('Session is already loaded.');
				return;
			}
			
			session.guest = true;
			session.guestQueue.forEach(callback => callback());
			session.guestQueue = [];
		},
		
		onLoaded: (callback) => session.loaded
			? setTimeout(callback, 0)
			: session.queue.push(callback),
		
		onGuest: (callback) => session.guest
			? setTimeout(callback, 0)
			: session.guestQueue.push(callback),
	},
	helpers: {
		loadEcho,
	},
};
